Backbone.Radio.channel('time').reply('convertMStoObject',function(milliseconds){
	var days, hours, minutes, seconds;
	seconds = Math.floor(milliseconds / 1000);
	minutes = Math.floor(seconds / 60);
	seconds = seconds % 60;
	hours = Math.floor(minutes / 60);
	minutes = minutes % 60;
	days = Math.floor(hours / 24);
	hours = hours % 24;
	return { days: days, hours: hours, minutes: minutes, seconds: seconds };		
})
Backbone.Radio.channel('time').reply('formatDuration',function(duration){
	if(typeof duration === "number"){ duration = Backbone.Radio.channel('time').request('convertMStoObject',duration) }
	
	durationText = '';
	if(	   duration.seconds !== 0
		|| duration.minutes !== 0
		|| duration.hours   !== 0
		|| duration.days 	!== 0
	){ 
		//add leading zeros
		if(duration.seconds < 10){ duration.seconds='0'+duration.seconds;  }
		//only add leading zero to minutes if we are showing hours
		if(duration.hours && duration.minutes < 10){ duration.minutes='0'+duration.minutes;  }
		
		if(duration.hours){ durationText+=duration.hours+"h "; }
		durationText+=duration.minutes+"m ";
		durationText+=duration.seconds+"s ";
	}
	return durationText;
})